import styled from "styled-components";

export const PersonName = styled.h3`
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 4px;
`

export const PersonFullName = styled.h4`
  font-size: 16px;
  font-weight: 700;
  padding-left: 4px;
`

export const LicenseString = styled.p`
  font-size: 16px;
`

export const ActionContent = styled.div`
  margin-top: 2px;
  padding-left: 4px;
  p {
    font-size: 16px;
  }
`


